<template>
  <component
    :is="isAutocomplete ? 'v-autocomplete' : 'v-select'"
    v-model="model"
    :placeholder="getProp('placeholder', 'Search')"
    :item-value="getProp('itemValue', 'value')"
    dense
    hide-details
    :item-text="getProp('itemText', 'name')"
    :menu-props="{ closeOnClick: true }"
    v-bind="$attrs"
    @change="onChange"
    v-on="$listeners"
  >
    <template #selection="{ item, index }">
      <div v-if="isMultiSelection">
        <div v-if="index === 0">
          <span v-if="isAllSeleted"> All </span>
          <span v-else>
            {{ item[getProp("itemValue", "name")] }}
            <span v-if="model.length > 1" class="grey--text caption">
              , (+{{ model.length - 1 }} selected)
            </span>
          </span>
        </div>
      </div>
      <div v-else>{{ item[getProp("itemValue", "name")] }}</div>
    </template>
  </component>
</template>

<script>
import {
  maybeCastBoolean,
  maybeCastNumber,
  maybeCastArray,
} from "@evercam/shared/utils"
import { camelizeKeys } from "humps"
import { VAutocomplete, VSelect } from "vuetify/lib"
export default {
  name: "SelectSearchField",
  components: {
    VAutocomplete,
    VSelect,
  },
  props: {
    fieldName: {
      type: String,
      default: "",
      mandatory: true,
    },
  },
  data() {
    return {
      model: null,
      isInitialized: false,
    }
  },
  computed: {
    isMultiSelection() {
      return this.$attrs?.multiple
    },
    isAutocomplete() {
      return this.$attrs?.isAutocomplete
    },
    isAllSeleted() {
      if (!this.isMultiSelection) {
        return
      }

      return this.model?.length === this.$attrs?.items?.length
    },
  },
  watch: {
    "$route.query": {
      handler() {
        this.updateFilterField()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    updateFilterField() {
      let route = camelizeKeys(this.$route.query)

      const rawValue = route[this.fieldName]
      let value = maybeCastArray(rawValue, this.$attrs.multiple)

      if (Array.isArray(value)) {
        value = value.map((item) => maybeCastNumber(maybeCastBoolean(item)))
      } else {
        value = maybeCastNumber(maybeCastBoolean(value))
      }

      if (["", null, undefined]?.includes(value) && !this.isInitialized) {
        this.model = this.$attrs?.value ?? ""
        this.isInitialized = true
      } else {
        this.model = value ?? ""
      }
    },
    getProp(propName, fallback) {
      if (Object.prototype.hasOwnProperty.call(this.$attrs, propName)) {
        return this.$attrs[propName]
      } else {
        return fallback
      }
    },
    onChange(mounted = false) {
      if (mounted && ["", null, undefined].includes(this.model)) {
        return
      }
      this.$emit("search", { [this.fieldName]: this.model })
    },
  },
}
</script>
